<template>
  <div class="dropdown icon-dropdown">
    <button
      class="btn dropdown-toggle"
      id="incomedropdown"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fa fa-ellipsis-v"></i>
    </button>
    <div
      class="dropdown-menu dropdown-menu-end"
      style="width: 250px !important"
      aria-labelledby="incomedropdown"
    >
      <div style="padding: 10px; background-color: #00a3e9; color: white">
        <h6 style="font-weight: bold">Insight</h6>
        <p>This insight was published 7 hours ago by XXX</p>
        <a style="text-decoration: underline">Learn More</a>
      </div>
      <a class="dropdown-item" href="#"
        ><i class="fa fa-thumbs-up m-r-5"></i>This insight is useful</a
      ><a class="dropdown-item" href="#"
        ><i class="fa fa-thumbs-down m-r-5"></i>This insight is not useful</a
      ><a class="dropdown-item" href="#"
        ><i class="fa fa-pencil-square-o m-r-5"></i>Propose new insight
      </a>
    </div>
  </div>
</template>
